import { Routes } from '@angular/router';
import { WorkflowService } from './services/workflow.service';
import { WorkflowRepository } from './repositories/workflow.repository';
import { TaskRepository } from './repositories/task.repository';
import { WorkflowTypesService } from './services/workflow-types.service';
import { WorkflowTypesRepository } from './repositories/workflow-types.repository';
import { TaskTypesRepository } from './repositories/task-types.repository';
import { TaskTypesService } from './services/task-types.service';
import { TasksRepository } from './repositories/tasks.repository';
import { TasksService } from './services/tasks.service';
import { TaskService } from './services/task.service';

export const workflowRoutes: Routes = [
  {
    path: 'workflow',
    providers: [
      WorkflowService,
      WorkflowRepository,
      TaskRepository,
      WorkflowTypesRepository,
      WorkflowTypesService,
      TaskTypesService,
      TaskTypesRepository,
      TasksRepository,
      TasksService,
    ],
    children: [
      {
        path: '',
        redirectTo: 'overview',
        pathMatch: 'full',
      },
      {
        path: 'overview',
        loadComponent: () =>
          import('./pages/workflow-overview/workflow-overview').then(
            (m) => m.WorkflowOverview
          ),
      },
      {
        path: 'monitor/:workflowType',
        providers: [TaskService],
        loadComponent: () =>
          import('./pages/workflow-monitor/workflow-monitor').then(
            (m) => m.WorkflowMonitor
          ),
      },
      {
        path: 'task/:taskId',
        loadComponent: () =>
          import('./pages/task-workflow/task-workflow').then((m) => m.TaskWorkflow),
      },
    ],
  },
];
